<template>
  <div class="etms-router-body">
    <div class="etms-router-search">
      <span class="etms-router-search-label fl">渠道名称：</span>
      <el-input size="mini" v-model="search.ChannelName" placeholder="填写渠道名称搜索" class="etms-router-search-element el-width-150 fl"></el-input>
      <span class="etms-router-search-label fl">承运商：</span>
      <el-select size="mini" v-model="search.CarriersId" placeholder="选择承运商搜索" class="etms-router-search-element el-width-150 fl" clearable filterable>
        <el-option v-for="item in CarriersList" :key="item.id" :value="item.id" :label="item.carriersName"></el-option>
      </el-select>
      <span class="etms-router-search-label fl">渠道分类：</span>
      <el-select size="mini" v-model="search.ChannelType" placeholder="选择渠道分类搜索" class="etms-router-search-element el-width-150 fl" clearable filterable>
        <el-option v-for="item in constant.channelType" :key="item.value" :value="item.value" :label="item.label"></el-option>
      </el-select>
      <span class="etms-router-search-label fl">线路分类：</span>
      <el-select size="mini" v-model="search.LineType" placeholder="选择线路分类搜索" class="etms-router-search-element el-width-150 fl" clearable filterable>
        <el-option v-for="item in constant.linetypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
      </el-select>
      <span class="etms-router-search-label fl">揽件地区：</span>
      <el-cascader size="mini" placeholder="请选择所在地区" :options="regionmodule.regions" v-model="search.CollectScope" filterable clearable change-on-select class="etms-router-search-element el-width-150 fl"></el-cascader>
      <span class="etms-router-search-label fl">状态：</span>
      <el-select size="mini" v-model="search.State" class="etms-router-search-element el-width-100 fl" clearable filterable>
        <el-option v-for="item in constant.commonstates" :key="item.value" :value="item.value" :label="item.label"></el-option>
      </el-select>
      <el-tooltip class="item" content="添加" placement="top">
        <el-button size="mini" type="primary" icon="el-icon-plus" class="etms-router-search-button fr" circle @click="insertChannel"></el-button>
      </el-tooltip>
      <el-tooltip class="item" content="搜索" placement="top">
        <el-button size="mini" type="primary" icon="el-icon-search" class="etms-router-search-button fr" circle @click="searchClick"></el-button>
      </el-tooltip>
      <div class="clear"></div>
    </div>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="search.pageindex" :page-sizes="constant.pagesizes" :page-size="search.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="search.recordcount"></el-pagination>
    <el-table :data="channellist" :border="true" height="90%" class="etms-router-list">
      <el-table-column label="序号" type="index" align="center"></el-table-column>
      <el-table-column label="承运商" align="center" prop="carriersId" width="200px" :formatter="formatterCarriersName">
      </el-table-column>
      <el-table-column label="渠道代码" align="center" prop="channelCode" width="100px"></el-table-column>
      <el-table-column label="渠道名称" align="center" prop="channelName">
      </el-table-column>
      <el-table-column label="渠道分类" align="center" prop="channelType" width="100px" :formatter="formatterChannelType"></el-table-column>
      <el-table-column label="线路分类" align="center" prop="channelLineType" width="100px" :formatter="formatterChannelLineType"></el-table-column>
      <el-table-column label="计费分类" align="center" prop="billingType" width="150px" :formatter="formatterBillingType"></el-table-column>
      <el-table-column label="重量限制" align="center" prop="maxWeight" width="100px" :formatter="formatterWeight"></el-table-column>
      <el-table-column label="长度限制" align="center" prop="maxWeight" width="100px" :formatter="formatterLong"></el-table-column>
      <el-table-column label="体积限制" align="center" prop="maxWeight" width="100px" :formatter="formatterVolume"></el-table-column>
      <el-table-column label="数量限制" align="center" prop="maxWeight" width="100px" :formatter="formatterQuantity"></el-table-column>
      <el-table-column label="状态" align="center" prop="state" width="70px" :formatter="formatterState"></el-table-column>
      <el-table-column label="操作" align="center" width="150px">
        <template slot-scope="scope">
          <el-tooltip class="item" content="修改" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-edit-outline" circle @click="editChannel(scope.$index,scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" content="导出" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-download" circle @click="exportChannel(scope.$index,scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" content="删除" placement="top">
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteChannel(scope.$index,scope.row)" v-show="scope.row.state !== 99"></el-button>
          </el-tooltip>
          <el-tooltip class="item" content="恢复" placement="top">
            <el-button size="mini" type="success" icon="el-icon-delete" circle @click="restoreChannel(scope.$index,scope.row)" v-show="scope.row.state === 99"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="dialogtitle" :visible.sync="dialogvisible" :modal-append-to-body="false" center>
      <el-tabs v-model="activename">
        <el-tab-pane label="渠道基本资料" name="channelbase" class="el-form-half">
          <el-form :ref="form.formname" :rules="rules" :model="form" label-width="130px" class="etms-dialog-form">
            <el-form-item label="承运商：" prop="CarriersId">
              <el-select size="mini" placeholder="请选择承运商" class="el-width-200" v-model="form.CarriersId">
                <el-option v-for="item in CarriersList" :key="item.id" :value="item.id" :label="item.carriersName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道代码：" prop="ChannelCode">
              <el-input size="mini" placeholder="请填写渠道代码" class="el-width-200" v-model="form.ChannelCode" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="渠道名称：" prop="ChannelName">
              <el-input size="mini" placeholder="请填写渠道名称" class="el-width-200" v-model="form.ChannelName" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="渠道分类：" prop="ChannelType">
              <el-select size="mini" placeholder="请选择渠道分类" class="el-width-200" v-model="form.ChannelType">
                <el-option v-for="item in constant.channelTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线路分类：" prop="ChannelLineType">
              <el-select size="mini" placeholder="请选择线路分类" class="el-width-200" v-model="form.ChannelLineType">
                <el-option v-for="item in constant.linetypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="计费分类：" prop="BillingType">
              <el-select size="mini" placeholder="请选择计费分类" class="el-width-200" v-model="form.BillingType">
                <el-option v-for="item in constant.billingWays" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="包裹进位分类：" prop="ParcelCarryType">
              <el-select size="mini" placeholder="请选择包裹进位分类" class="el-width-200" v-model="form.ParcelCarryType">
                <el-option v-for="item in constant.parcelCarryTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="预计天数：" prop="EstimateDays">
              <el-input-number size="mini" v-model="form.EstimatedMinDays" class="el-width-100" :precision="0"></el-input-number>
              -
              <el-input-number size="mini" v-model="form.EstimatedMaxDays" class="el-width-100" :precision="0"></el-input-number>
            </el-form-item>

            <el-form-item label="体积基数：">
              <el-input size="mini" type="number" placeholder="体积基数" class="el-width-100" v-model="form.VolumeBaseNum"></el-input>
            </el-form-item>
            <el-form-item label="单号规则：">
              <el-input size="mini" placeholder="请填写单号规则" class="el-width-200" v-model="form.OddRules"></el-input>
            </el-form-item>
            <el-form-item label="物品属性：">
              <el-select size="mini" v-model="form.ItemsAttributes" multiple collapse-tags placeholder="请选择物品属性" class="el-width-200">
                <el-option v-for="item in constant.itemsAttributes" :label="item.label" :value="item.value" :key="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="费用类型：">
              <el-select size="mini" v-model="form.FeeTypes" multiple collapse-tags placeholder="请选择费用类型" class="el-width-200">
                <el-option v-for="item in FeeTypeList" :label="item.feeTypeName" :value="item.id" :key="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物品类型：" prop="ItemTypes">
              <el-select size="mini" v-model="form.ItemTypes" multiple collapse-tags placeholder="请选择物品类型" class="el-width-200">
                <el-option v-for="item in constant.itemtypes" :label="item.label" :value="item.value" :key="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="打印标签：">
              <el-select size="mini" v-model="form.PrintLabels" multiple collapse-tags placeholder="请选择打印标签" class="el-width-200">
                <el-option v-for="item in PrintLabelList" :label="item.id" :value="item.id" :key="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序">
              <el-input-number size="mini" v-model="form.Sorting" class="el-width-100" :precision="0"></el-input-number>
            </el-form-item>
            <el-form-item label="区间限制：" class="el-form-item-fill" prop="LimitScope">
              <el-input size="mini" type="number" placeholder="重量" class="el-width-50" v-model="form.MinWeight" :max="form.MaxWeight" :min="0"></el-input>-
              <el-input size="mini" type="number" placeholder="重量" class="el-width-50" v-model="form.MaxWeight" :min="form.MinWeight"></el-input>kg
              <el-input size="mini" type="number" placeholder="长度" class="el-width-50" v-model="form.MinLong" :max="form.MaxLong" :min="0"></el-input>-
              <el-input size="mini" type="number" placeholder="长度" class="el-width-50" v-model="form.MaxLong" :min="form.MinLong"></el-input>cm
              <el-input size="mini" type="number" placeholder="体积" class="el-width-50" v-model="form.MinVolume" :max="form.MaxVolume" :min="0"></el-input>-
              <el-input size="mini" type="number" placeholder="体积" class="el-width-50" v-model="form.MaxVolume" :min="form.MinVolume"></el-input>m³
              <el-input size="mini" type="number" placeholder="数量" class="el-width-50" v-model="form.MinQuantity" :max="form.MaxQuantity" :min="0"></el-input>-
              <el-input size="mini" type="number" placeholder="数量" class="el-width-50" v-model="form.MaxQuantity" :min="form.MinQuantity"></el-input>件
            </el-form-item>
            <el-form-item label="渠道属性：" class="el-form-item-fill">
              <el-checkbox v-model="form.TrackState">可追踪</el-checkbox>
              <el-checkbox v-model="form.IsCollect">上门揽件</el-checkbox>
              <el-checkbox v-model="form.IsDelivery">派送上门</el-checkbox>
              <el-checkbox v-model="form.AllowBeyondState">允许超出限制</el-checkbox>
            </el-form-item>
            <div class="clear"></div>
            <el-form-item label="渠道简介：">
              <el-input size="mini" type="textarea" :rows="2" placeholder="请填写渠道简介" class="el-width-500" v-model="form.ChannelSynopsis"></el-input>
            </el-form-item>
            <div class="clear"></div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="渠道标签" name="channellabel">
          <el-table :data="form.ChannelLabels" :border="true" class="etms-router-list">
            <el-table-column type="index" label="序号" align="center" width="70px"></el-table-column>
            <el-table-column label="标签" align="center">
              <template slot-scope="scope">
                <el-input size="mini" placeholder="请填写标签" v-model="form.ChannelLabels[scope.$index]" class="el-width-300"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" width="100px">
              <template slot="header" slot-scope="scope">
                <el-tooltip class="item" content="添加渠道标签" placement="top">
                  <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="insertChannelLabel(scope)"></el-button>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-tooltip class="item" content="删除渠道标签" placement="top">
                  <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteChannelLabel(scope.$index)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="揽件范围" name="collectscope">
          <el-table :data="form.CollectScopes" :border="true" class="etms-router-list">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column label="揽收城市" align="center">
              <template slot-scope="scope">
                <el-cascader size="mini" placeholder="请选择所在地区" :options="regionmodule.regions" v-model="scope.row.region" filterable clearable change-on-select class="el-width-300"></el-cascader>
              </template>
            </el-table-column>
            <el-table-column align="center" width="100px">
              <template slot="header" slot-scope="scope">
                <el-tooltip class="item" content="添加揽件城市" placement="top">
                  <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="insertCollectScope(scope)"></el-button>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-tooltip class="item" content="删除" placement="top">
                  <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteCollectScope(scope.$index,scope.row)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="渠道进位" name="channelcarry" class="etms-router-list">
          <el-table :data="form.ChannelCarrys" :border="true">
            <el-table-column type="index" label="序号" width="60px" align="center"></el-table-column>
            <el-table-column label="起始值(不包含)" align="center">
              <template slot-scope="scope">
                <el-input-number size="mini" v-model="scope.row.startValue" class="el-width-100"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="结束值(包含)" align="center">
              <template slot-scope="scope">
                <el-input-number size="mini" v-model="scope.row.endValue" class="el-width-100"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="进位数" align="center">
              <template slot-scope="scope">
                <el-input-number size="mini" v-model="scope.row.carryValue" class="el-width-100"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column align="center" width="100px">
              <template slot="header" slot-scope="scope">
                <el-tooltip class="item" content="添加" placement="top">
                  <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="insertChannelCarry(scope)"></el-button>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-tooltip class="item" content="删除" placement="top">
                  <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteChannelCarry(scope.$index,scope.row)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="channelSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    var existsChannelCode = (rule, value, callback) => {
      var self = this
      var userinfo = this.$cookies.get('userinfo')
      if (userinfo !== null && userinfo !== undefined) {
        this.$ajax.post(this.constant.openPaths.existsChannelCode, {
          UserId: userinfo.id,
          EnterpriseId: userinfo.enterpriseId,
          LoginToken: userinfo.loginToken,
          ChannelCode: value,
          ChannelId: self.form.ChannelId
        }).then(res => {
          switch (res.data.code) {
            case 200:
              callback()
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              callback(res.data.msg)
              break;
          }
        }).catch(error => { callback(error) })
      }
    }
    var existsChannelName = (rule, value, callback) => {
      var self = this
      var userinfo = this.$cookies.get('userinfo')
      if (userinfo !== null && userinfo !== undefined) {
        this.$ajax.post(this.constant.openPaths.existsChannelName, {
          UserId: userinfo.id,
          EnterpriseId: userinfo.enterpriseId,
          LoginToken: userinfo.loginToken,
          ChannelName: value,
          ChannelId: self.form.ChannelId
        }).then(res => {
          switch (res.data.code) {
            case 200:
              callback()
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              callback(res.data.msg)
              break;
          }
        }).catch(error => { callback(error) })
      }
    }

    var estimateDaysValidate = (rule, value, callback) => {
      if (this.form.EstimatedMinDays !== null && this.form.EstimatedMinDays !== undefined && this.form.EstimatedMinDays !== '' && this.form.EstimatedMaxDays !== null && this.form.EstimatedMaxDays !== undefined && this.form.EstimatedMaxDays !== '') {
        if (this.form.EstimatedMinDays > this.form.EstimatedMaxDays) {
          callback('日期范围异常')
        }
      }
      callback()
    }

    var limitScopeValidate = (rule, value, callback) => {
      if (this.form.MinWeight !== null && this.form.MinWeight !== undefined && this.form.MinWeight !== '' && this.form.MaxWeight !== null && this.form.MaxWeight !== undefined && this.form.MaxWeight !== '') {
        if (this.form.MinWeight > this.form.MaxWeight) {
          callback('重量限制范围异常')
        }
      }
      if (this.form.MinLong !== null && this.form.MinLong !== undefined && this.form.MinLong !== '' && this.form.MaxLong !== null && this.form.MaxLong !== undefined && this.form.MaxLong !== '') {
        if (this.form.MinLong > this.form.MaxLong) {
          callback('长度限制范围异常')
        }
      }
      if (this.form.MinVolume !== null && this.form.MinVolume !== undefined && this.form.MinVolume !== '' && this.form.MaxVolume !== null && this.form.MaxVolume !== undefined && this.form.MaxVolume !== '') {
        if (this.form.MinVolume > this.form.MaxVolume) {
          callback('体积限制范围异常')
        }
      }
      if (this.form.MinQuantity !== null && this.form.MinQuantity !== undefined && this.form.MinQuantity !== '' && this.form.MaxQuantity !== null && this.form.MaxQuantity !== undefined && this.form.MaxQuantity !== '') {
        if (this.form.MinQuantity > this.form.MaxQuantity) {
          callback('数量限制范围异常')
        }
      }
      callback()
    }

    return {
      userinfo: this.$cookies.get('userinfo'),
      activename: 'channelbase',
      dialogtitle: '添加渠道',
      dialogvisible: false,
      CarriersList: [],
      FeeTypeList: [],
      PrintLabelList: [],
      form: {
        formname: 'channelform',
        OptimisticLock: '',
        Id: '',
        CarriersId: '',
        ChannelCode: '',
        ChannelName: '',
        ChannelCategory: '',
        LineType: '',
        ChannelType: '',
        ChannelLineType: '',
        BillingType: '',
        ParcelCarryType: '',
        EstimatedMinDays: '',
        EstimatedMaxDays: '',
        IsAllowBeyond: false,
        MinWeight: '',
        MaxWeight: '',
        MinLong: '',
        MaxLong: '',
        MinVolume: '',
        MaxVolume: '',
        MinQuantity: '',
        MaxQuantity: '',
        VolumeBaseNum: '',
        OddRules: '',
        ChannelSynopsis: '',
        TrackState: false,
        IsCollect: false,
        IsDelivery: '',
        Sorting: '',
        ItemsAttributes: [],
        CollectScopes: [],
        PrintLabels: [],
        FeeTypes: [],
        ChannelLabels: [],
        ChannelCarrys: [],
        ItemTypes: []
      },
      rules: {
        CarriersId: [
          { required: true, message: '请选择承运商', trigger: 'change' }
        ],
        ChannelCode: [
          { required: true, message: '请填写渠道代码', trigger: 'blur' },
          { max: 20, message: '长度请控制在20个字符以内', trigger: 'blur' },
          { validator: existsChannelCode, trigger: 'blur' }
        ],
        ChannelName: [
          { required: true, message: '请填写渠道名称', trigger: 'blur' },
          { max: 50, message: '长度请控制在50个字符以内', trigger: 'blur' },
          { validator: existsChannelName, trigger: 'blur' }
        ],
        ChannelType: [
          { required: true, message: '请选择渠道分类', trigger: 'change' }
        ],
        ChannelLineType: [
          { required: true, message: '请选择线路分类', trigger: 'change' }
        ],
        BillingType: [
          { required: true, message: '请选择计费方式', trigger: 'change' }
        ],
        ParcelCarryType: [
          { required: true, message: '请选择包裹进位方式', trigger: 'change' }
        ],
        EstimateDays: [
          { validator: estimateDaysValidate, trigger: 'blur' }
        ],
        LimitScope: [
          { validator: limitScopeValidate, trigger: 'blur' }
        ],
        ItemTypes: [
          { required: true, message: '请选择物品类型', trigger: 'change' }
        ]
      },
      search: {
        pageindex: 1,
        pagesize: 100,
        recordcount: 0,
        ChannelName: '',
        CarriersId: '',
        ChannelType: '',
        ChannelLineType: '',
        CollectScope: [],
        State: ''
      },
      channellist: []
    }
  },
  mounted () {
    this.initCarriers()
    this.initFeeTypes()
    this.searchClick()
  },
  methods: {
    initCarriers () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.getCarriersList, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.CarriersList = res.data.result
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    initFeeTypes () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.getFeeTypeList, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.FeeTypeList = res.data.result
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    searchClick () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          PageSize: this.search.pagesize,
          PageIndex: this.search.pageindex,
          ChannelName: this.search.ChannelName,
          CarriersId: this.search.CarriersId,
          ChannelType: this.search.ChannelType,
          ChannelLineType: this.search.ChannelLineType,
          CollectScope: this.search.CollectScope,
          State: this.search.State
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelPager, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.channellist = res.data.result.tList
              self.search.recordcount = res.data.result.recordCount
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        })
      }
    },
    formatterCarriersName (row, column) {
      var carriers = this.CarriersList.filter(item => item.id === row.carriersId)[0]
      if (carriers !== null && carriers !== undefined) {
        return carriers.carriersName
      }
      return ''
    },
    formatterChannelType (row, column) {
      var channelType = this.constant.channelTypes.filter(item => item.value === row.channelType)[0]
      if (channelType !== null && channelType !== undefined) {
        return channelType.label
      }
      return ''
    },
    formatterChannelLineType (row, column) {
      var lineType = this.constant.linetypes.filter(item => item.value === row.channelLineType)[0]
      if (lineType !== null && lineType !== undefined) {
        return lineType.label
      }
      return ''
    },
    formatterBillingType (row, column) {
      var billingType = this.constant.billingWays.filter(item => item.value === row.billingType)[0]
      if (billingType !== null && billingType !== undefined) {
        return billingType.label
      }
      return ''
    },

    formatterWeight (row, colums) {
      return this.formatterLimitScope(row.minWeight, row.maxWeight, 'kg')
    },
    formatterLong (row, colums) {
      return this.formatterLimitScope(row.minLong, row.maxLong, 'cm')
    },
    formatterVolume (row, colums) {
      return this.formatterLimitScope(row.minVolume, row.maxVolume, 'm³')
    },
    formatterQuantity (row, column) {
      return this.formatterLimitScope(row.minQuantity, row.maxQuantity, '件')
    },
    formatterLimitScope (min, max, unit) {
      var result = ''
      if (min > 0) {
        result = min
      }
      if (max > 0) {
        if (result !== '') {
          result += '-' + max + unit
        }
        else {
          result = max + unit + '以内'
        }
      }
      else {
        if (result !== '') {
          result = min + unit + '以上'
        }
      }
      return result
    },
    formatterState (row, column) {
      var state = this.constant.commonstates.filter(item => item.value === row.state)[0]
      if (state !== null && state !== undefined) {
        return state.label
      }
      return ''
    },
    clearForm () {
      var form = this.form
      Object.keys(form).forEach(item => {
        if (item !== 'formname') {
          switch (typeof (form[item])) {
            case 'string':
              form[item] = ''
              break
            case 'number':
              form[item] = ''
              break
            case 'object':
              if (Array.isArray(form[item])) {
                form[item] = []
              } else { }
              break
          }
        }
      })
    },
    insertChannel () {
      this.dialogvisible = true
      this.dialogtitle = '添加渠道'
      this.activename = 'channelbase'
      this.clearForm()
    },
    editChannel (index, row) {
      this.clearForm()
      this.activename = 'channelbase'
      this.dialogvisible = true
      this.dialogtitle = '修改渠道'
      this.form.Id = row.id
      this.form.OptimisticLock = row.optimisticLock
      this.form.CarriersId = row.carriersId
      this.form.ChannelCode = row.channelCode
      this.form.ChannelName = row.channelName
      this.form.ChannelType = row.channelType > 0 ? row.channelType : ''
      this.form.ChannelLineType = row.channelLineType > 0 ? row.channelLineType : ''
      this.form.BillingType = row.billingType > 0 ? row.billingType : ''
      this.form.ParcelCarryType = row.parcelCarryType > 0 ? row.parcelCarryType : ''
      this.form.EstimatedMinDays = row.estimatedMinDays
      this.form.EstimatedMaxDays = row.estimatedMaxDays
      this.form.IsAllowBeyond = row.isAllowBeyond
      this.form.MinWeight = row.minWeight > 0 ? row.minWeight : ''
      this.form.MaxWeight = row.maxWeight > 0 ? row.maxWeight : ''
      this.form.MinLong = row.minLong > 0 ? row.minLong : ''
      this.form.MaxLong = row.maxLong > 0 ? row.maxLong : ''
      this.form.MinVolume = row.minVolume > 0 ? row.minVolume : ''
      this.form.MaxVolume = row.maxVolume > 0 ? row.maxVolume : ''
      this.form.MinQuantity = row.minQuantity > 0 ? row.minQuantity : ''
      this.form.MaxQuantity = row.maxQuantity > 0 ? row.maxQuantity : ''
      this.form.VolumeBaseNum = row.volumeBaseNum > 0 ? row.volumeBaseNum : ''
      this.form.OddRules = row.oddRules
      this.form.ChannelSynopsis = row.channelSynopsis
      this.form.TrackState = row.trackState
      this.form.IsCollect = row.isCollect
      this.form.IsDelivery = row.isDelivery
      this.form.Sorting = row.sorting
      this.form.ItemsAttributes = row.itemsAttributes
      this.form.CollectScopes = row.collectScopes
      this.form.PrintLabels = row.printLabels
      this.form.FeeTypes = row.feeTypes
      this.form.ChannelCarrys = row.channelCarrys
      this.form.ChannelLabels = row.channelLabels
      this.form.ItemTypes = row.itemTypes ? row.itemTypes : []
    },
    exportChannel (index, row) {
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken,
        ChannelId: row.id
      }
      var self = this
      this.$ajax.post(this.constant.openPaths.exportChannelLine, data).then(res => {
        switch (res.data.code) {
          case 200:
            window.location.href = self.constant.openTmsUrl + res.data.result
            break;
          case 402:
            self.$router.push({ name: 'login' })
            break
          default:
            self.$message.error(res.data.msg)
            break;
        }
      }).catch(error => { self.$message.error(error) })
    },
    deleteChannel (index, row) {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: row.id,
          OptimisticLock: row.optimisticLock,
        }
        var self = this
        this.$confirm('此操作将删除渠道,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          self.$ajax.post(self.constant.openPaths.deleteChannel, data).then(res => {
            switch (res.data.code) {
              case 200:
                self.$message({ message: res.data.msg, type: 'success' })
                self.searchClick()
                break;
              case 402:
                self.$router.push({ name: 'login' })
                break
              default:
                self.$message.error(res.data.msg)
                break;
            }
          }).catch(error => { self.$message.error(error) })
        })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    restoreChannel (index, row) {
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken,
        Id: row.id,
        OptimisticLock: row.optimisticLock,
      }
      var self = this

      self.$ajax.post(self.constant.openPaths.restoreChannel, data).then(res => {
        switch (res.data.code) {
          case 200:
            self.$message({ message: res.data.msg, type: 'success' })
            self.searchClick()
            break;
          case 402:
            self.$router.push({ name: 'login' })
            break
          default:
            self.$message.error(res.data.msg)
            break;
        }
      }).catch(error => { self.$message.error(error) })
    },
    handleSizeChange (val) {
      this.pagesize = val
      this.init()
    },
    handleCurrentChange (val) {
      this.pageindex = val
      this.init()
    },
    channelSave () {

      if (this.userinfo !== null && this.userinfo !== undefined) {
        var channelLabels = new Array()

        this.form.ChannelLabels.forEach(item => {
          if (item !== '') {
            if (channelLabels.filter(i => i === item).length < 1) {
              channelLabels.push(item)
            }
          }
        })

        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: this.form.Id,
          OptimisticLock: this.form.OptimisticLock,
          CarriersId: this.form.CarriersId,
          ChannelCode: this.form.ChannelCode,
          ChannelName: this.form.ChannelName,
          ChannelType: this.form.ChannelType,
          ChannelLineType: this.form.ChannelLineType,
          BillingType: this.form.BillingType,
          ParcelCarryType: this.form.ParcelCarryType,
          EstimatedMinDays: this.form.EstimatedMinDays,
          EstimatedMaxDays: this.form.EstimatedMaxDays,
          IsAllowBeyond: this.form.IsAllowBeyond,
          MaxWeight: this.form.MaxWeight,
          MaxLong: this.form.MaxLong,
          MaxVolume: this.form.MaxVolume,
          MaxQuantity: this.form.MaxQuantity,
          VolumeBaseNum: this.form.VolumeBaseNum,
          OddRules: this.form.OddRules,
          ChannelSynopsis: this.form.ChannelSynopsis,
          TrackState: this.form.TrackState,
          IsCollect: this.form.IsCollect,
          IsDelivery: this.form.IsDelivery,
          Sorting: this.form.Sorting,
          ItemsAttributes: this.form.ItemsAttributes,
          CollectScopes: this.form.CollectScopes,
          PrintLabels: this.form.PrintLabels,
          FeeTypes: this.form.FeeTypes,
          ChannelCarrys: this.form.ChannelCarrys,
          ChannelLabels: channelLabels,
          ItemTypes: this.form.ItemTypes
        }
        var url = ''
        if (this.form.Id === '' && this.form.OptimisticLock === '') {
          url = this.constant.openPaths.insertChannel
        } else {
          url = this.constant.openPaths.updateChannel
        }
        var self = this
        this.$refs[this.form.formname].validate((valid) => {
          if (valid) {
            self.$ajax.post(url, data).then(res => {
              switch (res.data.code) {
                case 200:
                  self.$message({ message: res.data.msg, type: 'success' })
                  self.clearForm()
                  self.searchClick()
                  self.dialogvisible = false
                  break;
                case 402:
                  self.$router.push({ name: 'login' })
                  break
                default:
                  self.$message.error(res.data.msg)
                  break;
              }
            }).catch(error => {
              self.$message.error(error)
            })
          }
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    insertChannelLabel () {
      this.form.ChannelLabels.push('')
    },
    deleteChannelLabel (index) {
      this.form.ChannelLabels.slice(index, 1)
    },
    insertCollectScope () {
      this.form.CollectScopes.push({})
    },
    deleteCollectScope (index, row) {
      this.form.CollectScopes.splice(index, 1)
    },
    insertChannelCarry () {
      this.form.ChannelCarrys.push({})
    },
    deleteChannelCarry (index, row) {
      this.form.ChannelCarrys.splice(index, 1)
    },
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/channel_manage.vue